export function byCount(arr: string[]): string[] {
  const a: string[] = [];
  const L = arr.length;
  const o: Record<string, number> = {};
  for (let i = 0; i < L; i++) {
    const itm = arr[i];
    if (!itm) continue;
    if (o[itm] == undefined) o[itm] = 1;
    else ++o[itm];
  }
  for (const p in o) a[a.length] = p;
  return a.sort(function (a: string, b: string) {
    return (o[b] ?? 0) - (o[a] ?? 0);
  });
}
